import React, { FunctionComponent } from 'react';
import { Col, Hero } from '@visalex/core';
import { NullableSelectOption, Select, SelectOption } from '@visalex/forms';

import styles from './FAQHero.module.scss';

export type FaqHeroProps = {
  options: SelectOption[];
  handleSearchOptionChange: (newValue: NullableSelectOption) => void;
  title: string;
  searchPlaceholder: string;
};

export const FaqHero: FunctionComponent<FaqHeroProps> = ({
  options,
  handleSearchOptionChange,
  title,
  searchPlaceholder,
}) => {
  return (
    <Hero isAnimationEnabled={false} className={styles.faq__hero}>
      <Col xs={10} className="mx-auto">
        <h1 className={styles.faq__hero_title}>{title}</h1>
        <Select
          name="search"
          placeholder={searchPlaceholder}
          options={options}
          onChange={(newValue) => {
            handleSearchOptionChange(newValue);
          }}
        />
      </Col>
    </Hero>
  );
};
